//------------------//
// Flickity.js
//------------------//
import Flickity from 'flickity-imagesloaded';
import 'flickity/dist/flickity.css';
import '../scss/vendor/flickity.scss';
global.Flickity = Flickity;


//------------------//
// Alpine.js
//------------------//
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
// import focus from '@alpinejs/focus';
global.Alpine = Alpine;

Alpine.plugin(collapse);
// Alpine.plugin(focus);
Alpine.start();


// fitvids
import fitvids from 'fitvids';
global.fitvids = fitvids;
fitvids();


// ===================================================
// Global Functions
// ===================================================
function isTouchDevice() {
    return (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0));
}


// ===================================================
// Set html class that is used to determine if touch device
// ===================================================
if (isTouchDevice()) {
    document.documentElement.classList.add('is-touch-device');
}

window.addEventListener('resize', () => {
    if (isTouchDevice()) {
        document.documentElement.classList.add('is-touch-device');
    } else if (!isTouchDevice() && document.documentElement.classList.contains('is-touch-device')) {
        document.documentElement.classList.remove('is-touch-device');
    }
});



//------------------//
// Import GSAP & ScrollTrigger
//------------------//
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollSmoother } from 'gsap/ScrollSmoother';
import { SplitText } from "gsap/SplitText";

gsap.registerPlugin(ScrollTrigger, SplitText, ScrollSmoother);

window.gsap = gsap;
window.ScrollSmoother = ScrollSmoother;
window.ScrollTrigger = ScrollTrigger;

const smoother = ScrollSmoother.create({
    wrapper: '#smooth-wrapper',
    content: '#smooth-content',
    // smooth: false,
    effects: true
});

// ===================================================
// Set padding for nav since it's absolute positioned
// ===================================================
const nav_header_css_var = '--nav-header-height';
const navigation = document.querySelector('#navigation');

// Set initial css variable for nav heaight
let nav_height = parseFloat(navigation.getBoundingClientRect().height.toFixed(3));
document.documentElement.style.setProperty(nav_header_css_var, `${nav_height}px`);
window.nav_height = nav_height;

// smoothContent.style.paddingTop = navigation.getBoundingClientRect().height.toFixed(3) + 'px';

window.addEventListener('resize', (e) => {
    let nav_height = parseFloat(navigation.getBoundingClientRect().height.toFixed(3));

    // smoothContent.style.paddingTop = navigation.getBoundingClientRect().height.toFixed(3) + 'px';

    // Set css variable for nav height
    document.documentElement.style.setProperty(nav_header_css_var, `${nav_height}px`);
    window.nav_height = nav_height;
});


// function titleAnimations() {
//     const titles = gsap.utils.toArray('.animated-title');

//     titles.forEach((title) => {
//         let splitTitle = new SplitText(title, {
//             type: 'lines, words, chars',
//             linesClass: 'split-line'
//         });
//         let chars = splitTitle.chars;

//         gsap.from(chars, {
//             // opacity: 0,
//             y: 50,
//             ease: 'power2.out',
//             stagger: 0.01,
//             duration: 0.4,
//             scrollTrigger: {
//                 trigger: title,
//                 // markers: true,
//                 id: 'Animated Titles',
//                 start: 'top bottom-=100px',
//                 end: 'top bottom-=100px',
//             }
//         });
//     });
// }

// titleAnimations();





//------------------//
// Import Fancybox
//------------------//
import { Fancybox } from "@fancyapps/ui";
Fancybox.bind('[data-fancybox]', {
    on: {
        init: (fancybox, eventName) => {
            if (global.smoother) global.smoother.paused(true);
        },
        close: () => {
            if (global.smoother) global.smoother.paused(false);
        }
    },
});



//------------------//
// Blobby
//------------------//
const blob = document.getElementById('blob');

if (!isTouchDevice()) {
    document.body.onpointermove = event => {
        const { clientX, clientY } = event;
        blob.animate({
            left: `${clientX - 300}px`,
            top: `${clientY - 300}px`
        }, {duration: 5000, fill: 'forwards'});
    }
}






//------------------//
// Lazy load images
//------------------//
import Lazyload from 'vanilla-lazyload';
global.Lazyload = Lazyload;

// Create Lazy load instance
var lazyLoadInstance = new Lazyload({
    elements_selector: '.lazy'
    // ... more custom settings?
});
global.lazyLoadInstance = lazyLoadInstance;








// ------------------ //
// Button Hover Effect
// ------------------ //
const buttonHover = (e) => {
    const { currentTarget: target } = e;

    const rect = target.getBoundingClientRect(),
        x = e.clientX - rect.left;

    target.style.setProperty('--button-mouse-x', `${ x }px`);
}

if (!isTouchDevice()) {
    for(const button of document.querySelectorAll('.btn')) {
        button.onmousemove = (e) => buttonHover(e)
    }
}





// ------------------ //
// Diagonal Hover Effect
// ------------------ //
const diagonalLines = document.querySelectorAll('[class^="diagonal-lines-"]');

window.addEventListener('scroll', () => {
    const scrollY = window.scrollY;
    diagonalLines.forEach(element => {
        element.style.backgroundPositionY = `${scrollY / 5}px`;
    });
});




// ------------------ //
// Scrolling Swipe Transitions
// ------------------ //
const swipeReveals = document.querySelectorAll('.swipe-reveal');

// Use ScrollTrigger to add a class when the swipeTransition scrolls into view
swipeReveals.forEach((swipeReveal) => {
    ScrollTrigger.create({
        trigger: swipeReveal,
        start: "+=200px bottom",
        // markers: true,
        onEnter: () => {
            swipeReveal.classList.add('swipe-visible');
        },
        onLeaveBack: () => {
            swipeReveal.classList.remove('swipe-visible');
        },
    });
});


//------------------//
// Scroll Fade In with small Y Translate
//------------------//
gsap.set(".list-fadeInUp", {
    y: 25,
    opacity: 0,
});

ScrollTrigger.batch('.list-fadeInUp', {
    onEnter: batch => gsap.to(batch, {
        opacity: 1,
        y: 0,
        duration: 0.5,
        stagger: 0.25,
    })
});



//------------------//
// Import Scrolling animations
//------------------//
import scrollingAnimations from './scrolling-animations';

scrollingAnimations.create({
    once: false
});


//------------------//
// Testimonial slider
//------------------//
document.querySelectorAll('[data-testimonial-slider]').forEach((item) => {
    new Flickity(item, {
        pageDots: false,
        cellAlign: 'center',
        prevNextButtons: true
    });
});


// ===================================================
// Services Landing Page
// ===================================================
const serviceSection = document.querySelector('#service-list');

if (serviceSection && !isTouchDevice()) {
    ScrollTrigger.create({
        trigger: serviceSection.querySelector('#service-image-container'),
        endTrigger: serviceSection,
        start: "center center",
        end: "bottom bottom",
        pin: true,
    })
}


// ===================================================
// Blog article figure caption width fix
// ===================================================
const articleContent = document.getElementById('article-content');

if (articleContent) {
    const articleFigures = articleContent.querySelectorAll('figure');

    articleFigures.forEach((figure) => {
        const image = figure.querySelector('img');
        const figcaption = figure.querySelector('figcaption');

        if (figcaption) {
            image.addEventListener('load', () => {
                figcaption.style.width = `${image.getBoundingClientRect().width}px`;
            }, { once: true });
        }
    });
}